import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Input, Button, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { BookOpen, Edit3, Trash2 } from "lucide-react";

const { TextArea } = Input;

const validationSchema = Yup.object().shape({
  instruction: Yup.string()
    .nullable()
    .max(300, "Maximum 300 characters allowed")
    .required("Instruction is required"),
});

const Instructions = ({
  editIndex,
  onSubmit = (values, { resetForm }) => {
    console.log(values);
    resetForm();
  },
  values = { instruction: null },
}) => {
  return (
    <Formik
      initialValues={values}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => (
        <Form layout="vertical" onFinish={handleSubmit}>
          <Row gutter={[16, 16]} align="middle">
            <Col span={12}>
              <Form.Item
                label="Instruction"
                validateStatus={
                  errors.instruction && touched.instruction ? "error" : ""
                }
                help={
                  errors.instruction && touched.instruction
                    ? errors.instruction
                    : null
                }
              >
                <TextArea
                  name="instruction"
                  rows={2}
                  className="w-full"
                  placeholder="Instruction"
                  value={values.instruction}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Button type="primary" htmlType="submit" block>
                {editIndex !== null ? "Update" : "Add"}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default Instructions;

export const InstructionsCard = ({ item, fromView, onEdit, onDelete }) => {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 shadow-sm hover:shadow-md transition p-3 text-sm">
      {/* Header */}
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <div className="p-1.5 bg-blue-100 rounded-md">
            <BookOpen className="w-4 h-4 text-blue-600" />
          </div>
          <p
            className="text-gray-900 dark:text-slate-100 leading-tight text-base break-all"
            title={item.instruction}
          >
            {item.instruction}
          </p>
        </div>

        {!fromView && (
          <div className="flex items-center gap-1">
            {onEdit && (
              <button
                type="button"
                className="p-1.5 rounded-md hover:bg-blue-50 transition-colors border border-transparent hover:border-blue-200"
                onClick={() => onEdit()}
                title="Edit instruction"
              >
                <Edit3 className="w-4 h-4 text-blue-600" />
              </button>
            )}
            {onDelete && (
              <button
                type="button"
                className="p-1.5 rounded-md hover:bg-red-50 transition-colors border border-transparent hover:border-red-200"
                onClick={() => onDelete()}
                title="Delete instruction"
              >
                <Trash2 className="w-4 h-4 text-red-500" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
